<template>
    <div class="row left-content justify-content-center">
        <div class="col-12">
            <h1>Create dwolla withdraw</h1>
        </div>
        <div class="col-5">
            <div class="white-block">
                <div class="container">
                    <b-form>
                        <b-form-checkbox
                            v-model="isPartial"
                            class="mb-2"
                            @change="form.amount = null"
                        >
                            Partial withdraw
                        </b-form-checkbox>
                        <b-form-input
                            v-if="isPartial"
                            v-model="form.amount"
                            type="text"
                            placeholder="Amount ($)"
                            class="mb-2"
                        ></b-form-input>
                        <hr/>
                        <b-form-checkbox
                            v-model="form.expedited"
                            class="mb-2"
                        >
                            Expedited
                        </b-form-checkbox>
                        <b-form-checkbox
                            v-model="form.withCommission"
                            class="mb-2"
                        >
                            With Commission
                        </b-form-checkbox>

                        <b-button variant="primary" type="submit" @click.prevent.stop="withdraw()">Withdraw</b-button>
                    </b-form>
                    <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";
import {UrlMixin} from "@/views/admin/Wallet/ProjectWallet/UrlMixin";
export default {
    name: "CreateTransfer",
    props: ['id'],
    mixins: [ServerErrors, UrlMixin],
    data() {
        return {
            errors: [],
            isPartial: false,
            form: {
                amount: null,
                expedited: false,
                withCommission: false
            }
        }
    },
    methods: {
        withdraw() {
            let loader = this.$loading.show();
            this.errors = [];
            console.log({
                amount: this.form.amount ? parseFloat(this.form.amount) : null,
                expedited: this.form.expedited,
                with_commission: this.form.withCommission
            });

            window.axios({
                method: 'POST',
                url: this.getUrl('/admin/wallet/project/wallet/' + this.id + '/transfer/withdraw-manual'),
                data: {
                    amount: parseFloat(this.form.amount),
                    expedited: this.form.expedited,
                    with_commission: this.form.withCommission
                }
            })
                .then(() => {
                    this.$router.push({ name: 'admin.project_wallet.client.view', params: { page: this.id } });
                })
                .catch(error => {
                    this.errors = this.server_errors;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    }
}
</script>